import { Route } from "@dashboard/components/Router";
import { sectionNames } from "@dashboard/intl";
import { useIntl } from "react-intl";
import { Switch } from "react-router-dom";

import { WindowTitle } from "../components/WindowTitle";
import { labelPrintingBatchesPath, labelPrintingHelpPath, labelPrintingSection } from "./urls";
import { LabelBatches } from "./views/LabelBatches/LabelBatches";
import { LabelPrintingHelp } from "./views/LabelPrintingHelp/LabelPrintingHelp";
import { LabelPrintingOverview } from "./views/LabelPrintingOverview/LabelPrintingOverview";

const LabelPrintingSection = () => {
  const intl = useIntl();

  return (
    <>
      <WindowTitle title={intl.formatMessage(sectionNames.printLabels)} />
      <Switch>
        <Route path={labelPrintingBatchesPath} component={LabelBatches} />
        <Route path={labelPrintingHelpPath} component={LabelPrintingHelp} />
        <Route path={labelPrintingSection} component={LabelPrintingOverview} />
      </Switch>
    </>
  );
};

export default LabelPrintingSection;
